import { JSXMapSerializer, PrismicRichText, SliceComponentProps } from '@prismicio/react'
import { TextSlice } from './UpsellModalPrismicDocument'
import { Typography } from '@dtx-company/design-system/src'
import { UpsellModalLinkSerializer } from './UpsellModalLinkSerializer'

export const upsellModalTextSerializer: JSXMapSerializer = {
  hyperlink: UpsellModalLinkSerializer,
  heading4: ({ children }) => (
    <Typography color="inherit" variant="bodySmall" component="h4">
      {children}
    </Typography>
  ),
  paragraph: ({ children }) => (
    <Typography color="inherit" variant="bodySmall" component="p">
      {children}
    </Typography>
  )
}

export const UpsellModalTextSlice = ({
  slice
}: SliceComponentProps<TextSlice>): JSX.Element | null => {
  const {
    primary: { content }
  } = slice

  return <PrismicRichText field={content} components={upsellModalTextSerializer} />
}
